<template>
  <div class="collect-item">
    <van-list
      class="coll-item"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      offset="0"
      @load="onLoad"
    >
      <div
        class="item"
        v-for="item in topics"
        :key="item.id"
        @click="topicsClick(item)"
      >
        <div
          class="status"
          v-if="
            tag == 1 &&
            (item.status === 0 || item.status === 2 || item.status === 4)
          "
        >
          {{ isStatus(item.status) }}
        </div>
        <van-icon
          v-if="tag == 1"
          class="item-delete"
          name="delete-o"
          @click.stop="deleteTopics(item)"
        />
        <van-icon
          v-if="tag == 1"
          class="item-edit"
          name="edit"
          @click.stop="editTopics(item)"
        />

        <van-image
          v-if="showCoverImg(item.media_list)"
          class="item-img"
          fit="cover"
          :src="coverImg(item.media_list)"
        />
        <div v-else class="goods-image-text van-multi-ellipsis--l3">
          {{ item.content }}
        </div>
        <div class="content">
          <span class="comment">评论({{ item.reply_count }})</span>
          <span class="praise">赞({{ item.like_count }})</span>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { deleteTopics, editTopics } from "network/profile";

export default {
  name: "CollectItem",
  components: {},
  props: {
    tag: Number,
    topics: Array,
  },
  data() {
    return {
      loading: false,
      finished: false,
    };
  },
  computed: {
    coverImg() {
      return (imgs) => {
        let pics = imgs.filter((item) => item.type == "image");
        return pics.length > 0
          ? pics[0].url
          : require("../../../assets/img/loading.gif");
      };
    },
    showCoverImg() {
      return (imgs) => {
        let pics = imgs.filter((item) => item.type == "image");
        return pics.length > 0;
      };
    },
    isStatus() {
      return (status) => {
        if (status === 0) {
          return "未审核";
        } else if (status === 1) {
          return "";
        } else if (status === 2) {
          return "未通过";
        } else if (status === 4) {
          return "未审核";
        } else {
          return "";
        }
      };
    },
  },
  created() {},
  mounted() {},
  methods: {
    //加载更多
    onLoad() {
      this.$emit("loadMore", (loading) => {
        this.loading = false;
        this.finished = loading;
      });
    },
    //点击帖子
    topicsClick(item) {
      this.$router.push({
        path: "/homepostdefault",
        query: {
          id: item.id,
        },
      });
    },
    //删除帖子
    deleteTopics(item) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认要删除吗？",
        })
        .then(() => {
          deleteTopics(item.id).then((res) => {
            this.topics.splice(this.topics.indexOf(item), 1);
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    //编辑帖子
    editTopics(item) {
      this.$router.push({
        path: "/postedit",
        query: {
          id: item.id,
        },
      });
    },
  },
  watch: {},
};
</script>
<style scoped>
.collect-item {
  margin-bottom: 60px;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 5px 0 5px;
  background: #fff;
  display: flex;
}
.coll-item {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.item {
  position: relative;
}
.item-delete {
  position: absolute;
  top: 0;
  right: 0;
  padding: 2px;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.2);
}
.item-edit {
  position: absolute;
  top: 130px;
  right: 0;
  padding: 2px;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.2);
}
.status {
  position: absolute;
  padding: 2px 5px;
  z-index: 1;
  border-bottom-right-radius: 2px;
  font-size: 12px;
  background-color: rgba(0, 0, 0, 0.2);
  color: #fff;
}
.item-img {
  width: 150px;
  height: 150px;
}
.goods-image-text {
  width: 150px;
  height: 150px;
  font-size: 13px;
  color: #707070;
}
.content {
  padding-bottom: 10px;
  color: #232323;
  font-size: 13px;
}
.comment {
  margin-right: 15px;
}
::v-deep .van-list__loading {
  width: 100%;
}
::v-deep .van-list__finished-text {
  width: 305px;
}
</style>